<template>
  <div class="students-grade-work-list">
    <div v-if="worksList.length" class="box-warp">
      <div v-for="(item, index) in worksList" :key="index" class="work-item">
        <div class="work-img-box" @click="goView(routerPath, item)">
          <img v-if="getFilesType(item.picUrl) === 1" :src="item.picUrl" alt="">
          <video v-if="getFilesType(item.picUrl) === 3" :src="item.picUrl"></video>
        </div>
        <div class="teacher-time">
          <div class="teacher"> 点评老师: {{ item.teacher }} </div>
          <div class="state-time">
            <div v-if="!item.state" class="state"> 未读 </div>
            <div class="time"> {{ item.time }} </div>
          </div>
        </div>
      </div>      
    </div>
  </div>
</template>

<script>
  import { commentWorksInfo } from '@api/grade'

  import { getFlieType, addZoo } from '@common'

  export default {
    name: 'StudentsGradeWorkList',
    data() {
      return {
        routerPath: '/grade/praiseInfoShow',
        worksList: []
      }        
    },
    methods: {
      getFilesType(url) {
        let type = getFlieType(url);
          if (type === 'image') { //图片
            return 1;
          }else if (type === 'radio') { //音乐
            return 2;
          }else if (type === 'video') { //视频
            return 3;
          }else {
            return 0;
          }
      },
      getCommentWorksInfo() {
        commentWorksInfo({ user_id: this.$route.params.uid }).then(res => {
          let result = res.data.information;
          let infoStore = [];
          for (let item of result) {
            infoStore.push(          {
              picUrl: item.video_images && item.video_images[0],
              teacher: item.staff_name,
              time: `${new Date(Number(item.datatime+'000')).getMonth()+1}.${addZoo(new Date(Number(item.datatime+'000')).getDate())}`,
              content_id: item.content_id,
              state: item.statusread
            })
          }
          this.worksList = infoStore;
        })
      },
      /**
       * 页面跳转
       */
      goView(path, data) {
        let params = {
          contentId: data.content_id,
        }
        this.$router.push({ path, query: params});
      }
    },
    mounted() {
      this.getCommentWorksInfo();
    }
  }
</script>

<style scoped>
  .students-grade-work-list{
    width: 100vw;
    min-height: 100vh;
    position: relative;
    background-color: white;
  }
  .box-warp {
    padding-bottom: 1rem;
  }
    .work-item {
      width: 100%;
      padding: 0.3rem 0.4rem;
      border-bottom: 0.02rem solid #ebebeb;
    }
      .work-img-box {
        width: 100%;
        padding: 0.3rem;
        border: 0.2rem solid black;
        box-shadow: 0.06rem 0.06rem 0.1rem #5e5e5e, 0.06rem 0.06rem 0.1rem #949494 inset;
        min-height: 2rem;
      }
        .work-img-box img, .work-img-box video {
          width: 100%;
          vertical-align: middle;
        }
      .teacher-time {
        padding: 0.3rem 0 0;
        display: flex;
        justify-content: space-between;
      }
        .state-time {
          display: flex;
        }
          .state {
            color: #c45353;
            margin-right: 0.16rem;
          }
          .time {
            color: #7f7f7f;
            display: flex;
            align-items: center;
          }
</style>